import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Button, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const PREFIX = 'PurchasesToolbar';

const classes = {
  root: `${PREFIX}-root`,
  row: `${PREFIX}-row`,
  spacer: `${PREFIX}-spacer`,
  balance: `${PREFIX}-balance`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },

  [`& .${classes.row}`]: {
    display: 'flex',
  },

  [`& .${classes.spacer}`]: {
    flexGrow: 1,
  },

  [`& .${classes.balance}`]: {
    marginTop: theme.spacing(1) + 2,
    marginLeft: theme.spacing(2),
    fontWeight: 'bold',
  },
}));

const PurchasesToolbar = props => {
  const { className, meetupId, info, ...rest } = props;

  return (
    <Root {...rest} className={clsx(classes.root, className)}>
      <div className={classes.row}>
        <Typography className={classes.balance}>Баланс: {info.balance}</Typography>
        <span className={classes.spacer} />
        <Button color='primary' variant='contained'>
          Вывести деньги
        </Button>
      </div>
    </Root>
  );
};

export default PurchasesToolbar;
